import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class routerHandl {
  routerHandl: any[] = [];
  constructor(private route: Router) {
    this.route.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (this.routerHandl.length < 10) {
          this.routerHandl.push(event.urlAfterRedirects);
        } else {
          this.routerHandl.push(event.urlAfterRedirects);
          this.routerHandl.shift();
        }
      });
  }
  getRouterHistory(): string[] {
    return [...this.routerHandl];
  }
  getLastUrl(): string | null {
    if (this.routerHandl.length > 1) {
      return this.routerHandl[this.routerHandl.length - 2]; // Lấy URL trước URL hiện tại
    }
    return null; // Nếu không có lịch sử trước đó
  }
}
